import API from '../../api/api';
import utils from '../../../modules/utils';

function isTokenReceived(status) {
  return status === 'HOSTED_PAYMENT_TOKEN_RECEIVED';
}

function isReturningFromHostedPage(queryParams) {
  return !!(utils.fn.getURIParam(queryParams, 'status') && utils.fn.getURIParam(queryParams, 'tno'));
}

function isProblemWithService(status) {
  return (status === 'HOSTED_PAYMENT_AUTHENTICATION_FAILED'
    || status === 'HOSTED_PAYMENT_CURRENTLY_UNAVAILABLE');
}

function returnedFromHostedPage() {
  return API.doAPIRequest('/v2/return-from-hosted/kcp');
}

export default {
  isTokenReceived, isProblemWithService, isReturningFromHostedPage, returnedFromHostedPage,
};
